import { bindings } from '@polleverywhere/slideware-bindings'
import LabFeatures from '@polleverywhere/core/lib/models/lab_features'

function disableFeatures (features) {
  const labs = new LabFeatures({ user: this })
  const update = features.reduce((attrs, feature) => {
    attrs[feature] = false
    return attrs
  }, {})

  labs.save(update).then(async () => {
    await bindings.login(this)
    bindings.closeWindow()
  })
}

export async function disableLabFeatures (app) {
  const dispatcher = _.clone(Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', async (state) => {
    dispatcher.listenTo(state, 'session:start', (user) => {
      dispatcher.listenTo(state.appStates.slideware, 'change:disableFeatures', (slidewareState, features, options) => {
        disableFeatures.call(user, features)
      })
    })
  })
}
